import classnames from "utilities/classnames";
import styles from "./styles.module.scss";

type HomeContentContainerProps = {
  className?: string;
  classNameInner?: string;
  style?: React.CSSProperties;
  styleInner?: React.CSSProperties;
  children?: React.ReactNode;
};

export function HomeContentContainer(props: HomeContentContainerProps) {
  const { className, children, classNameInner, style, styleInner } = props;

  return (
    <div className={classnames(styles.root, className)} style={style}>
      <div className={classnames(styles.inner, classNameInner)} style={styleInner}>
        {children}
      </div>
    </div>
  );
}
